import React, { lazy, Suspense, useEffect } from 'react';

/// Components
import Index from "./jsx";
import { connect, useDispatch } from 'react-redux';
import {  Route, Routes, useLocation , useNavigate , useParams } from 'react-router-dom';
// action
import { checkAutoLogin } from './services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';
/// Style
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
import Home from './jsx/pages/Dashboard/Dashboard';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { usePageTitle } from "./jsx/components/hooks/routeTitleMap"

const Login = lazy(() => import('./jsx/pages/Login'));
const ForgotPassword = lazy(() => import('./jsx/pages/ForgotPassword'));

// function withRouter(Component) {
//   function ComponentWithRouterProp(props) {
//     let location = useLocation();
//     let navigate = useNavigate();
//     let params = useParams();
	
//     return (
//       <Component
//         {...props}
//         router={{ location, navigate, params }}
//       />
//     );
//   }

//   return ComponentWithRouterProp;
// }



// function App (props) {
//     const dispatch = useDispatch();
// 	  const navigate = useNavigate();
//     useEffect(() => {
//       checkAutoLogin(dispatch, navigate);
//    }, [dispatch, navigate]);
    
   

//     let routeblog = ( 
        
//         <Routes>
//           <Route path='/login' element={<Login />} />
//           <Route path='/page-forgot-password' element={<ForgotPassword />} />
//         </Routes>
//     );
//     if (props.isAuthenticated) {
// 		return (
// 			<>
//                 <Suspense fallback={
//                     <div id="preloader">
//                         <div className="sk-three-bounce">
//                             <div className="sk-child sk-bounce1"></div>
//                             <div className="sk-child sk-bounce2"></div>
//                             <div className="sk-child sk-bounce3"></div>
//                         </div>
//                     </div>  
//                    }
//                 >
// 				<Index / > 
//                 </Suspense>
//             </>
//         );
	
// 	}else{
// 		return (
// 			// <div className="vh-100">
//                 <Suspense fallback={
//                     <div id="preloader">
//                         <div className="sk-three-bounce">
//                             <div className="sk-child sk-bounce1"></div>
//                             <div className="sk-child sk-bounce2"></div>
//                             <div className="sk-child sk-bounce3"></div>
//                         </div>
//                     </div>
//                   }
//                 >
//                     {routeblog}
//                 </Suspense>
// 			// </div>
// 		);
// 	}
// };

function App(props) {
  usePageTitle();
  return (
      <Suspense fallback={<div>Loading...</div>}>
          <Routes>
              <Route path='/login' element={<Login />} />
              <Route path='/page-forgot-password' element={<ForgotPassword />} />

              {/* Use PrivateRoute for dashboard */}
              <Route path='/dashboard' element={<Home />} />
          </Routes>
          <Index/>
            <ToastContainer
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
      </Suspense>
  );
}

// const mapStateToProps = (state) => {
//     return {
//         isAuthenticated: isAuthenticated(state),
//     };
// };

//export default connect((mapStateToProps)(App)); 
// export default withRouter(connect(mapStateToProps)(App)); 
export default App; 

